import type { StateMapping, WidgetTone } from "./types";

export const STATE_TONES: readonly WidgetTone[] = ["neutral", "info", "ok", "warn", "danger"];
export const MAX_STATE_MAPPINGS = 16;

/** Uma tabela ambigua nao classifica NENHUM codigo. Nunca escolhe o primeiro. */
export function normalizeStateMappings(value: unknown): StateMapping[] | undefined {
  if (!Array.isArray(value) || value.length === 0 || value.length > MAX_STATE_MAPPINGS) return undefined;
  const seen = new Set<number>();
  const result: StateMapping[] = [];
  for (const item of value) {
    if (!item || typeof item !== "object") return undefined;
    const row = item as Record<string, unknown>;
    if (typeof row.value !== "number" || !Number.isFinite(row.value) || seen.has(row.value) ||
        typeof row.label !== "string" || !row.label.trim() || row.label.trim().length > 80 ||
        !STATE_TONES.includes(row.tone as WidgetTone)) return undefined;
    seen.add(row.value);
    result.push({ value: row.value, label: row.label.trim(), tone: row.tone as WidgetTone });
  }
  return result;
}
